import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconProp } from '@fortawesome/fontawesome-svg-core';

export interface ActionButtonProps {
  icon: IconProp;
  label: string;
  onClick?: () => void;
  className?: string;
}

export default function ActionButton({
  icon,
  label,
  onClick,
  className = '',
}: ActionButtonProps) {
  return (
    <div
      className={`inline-flex items-center bg-black/50 rounded-full text-white px-2 py-1 hover:bg-black/100 transition-colors ${className}`}
      role='button'
      onClick={onClick}
    >
      <FontAwesomeIcon className='text-xl' icon={icon} />
      <span className='ml-2'>{label}</span>
    </div>
  );
}
